module.exports = __webpack_public_path__ + "static/robertogentile.5227855b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/robertogentile.svg
// module id = 898
// module chunks = 730474649440 220147872750301